import { IntegrationId } from 'integrations/common/streams/tabularMappings/types';
import { SourceType } from '@ardoq/api-types/integrations';
import { INTEGRATION_ID_TO_SOURCE_TYPES } from 'integrations/unified/constants';

const sourceTypesByIntegrationId: Record<IntegrationId, SourceType[]> = {
  'aws-v3': ['aws'],
  'azure-v3': ['azure'],
  'excel-v3': ['sheets'],
  'json-importer': ['json'],
  'servicenow-v3': ['servicenow'],
  'signavio-exporter': ['signavio-exporter'],
  'servicenow-guided-exporter': ['servicenow-guided-exporter'],
  'it-pedia': ['itpedia'],
  'celonis-exporter': ['celonis-exporter'],
  ...INTEGRATION_ID_TO_SOURCE_TYPES,
};

export const IntegrationIdBySourceTypes = Object.entries(
  sourceTypesByIntegrationId
).reduce(
  (acc, [integrationId, sourceTypes]) => {
    sourceTypes.forEach(sourceType => {
      acc[sourceType] = (acc[sourceType] || []).concat(
        integrationId as IntegrationId
      );
    });
    return acc;
  },
  {} as Record<SourceType, IntegrationId[]>
);

export const integrationIdToSourceTypes = (integrationId: IntegrationId) => {
  return sourceTypesByIntegrationId[integrationId] || [];
};
